module.exports = __webpack_public_path__ + "prod/1.42.2/img/promotion_bg.e5cd33fb.png";